import React from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import cn from "utils/cn";
export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const menuItems = [
    { name: "home.home", path: "/" },
    { name: "home.aboutUs", path: "/about-us" },
    { name: "home.ourServices", path: "/our-services" },
    { name: "home.ourStrength", path: "/our-strength" },
    { name: "home.contactUs", path: "/contact-us" },
  ];
  const datas = [
    { title: "footer.phone", content: "+852-3621 0366" },
    { title: "footer.email", content: "master@sinoasiabnr.com" },
    { title: "footer.fas", content: "+852-3621 0393" },
  ];
  return (
    <footer className="bg-[#000] flex flex-col justify-center items-center">
      <div className="bg-container flex flex-wrap gap-5 text-[#fff] py-10 px-5 text-base md:py-[80px] md:px-[50px] md:gap-4 lg:text-lg lg:gap-12">
        <div className="flex-1 flex text-white flex-col min-w-[300px] gap-4">
          {menuItems.map((item, index) => (
            <a
              key={`nav-${index}`}
              href={item.path}
              onClick={(e) => {
                e.preventDefault();
                navigate(item.path);
              }}
              className={cn(
                " text-base font-medium hover:underline whitespace-nowrap lg:text-lg"
              )}
            >
              {t(item.name)}
            </a>
          ))}
        </div>
        <div className="flex-1 min-w-[313px]">
          <div className="font-bold">{t("footer.addressTitle")}</div>
          <div className="font-bold pb-4">{t("home.aboutTitle")}</div>
          <div>{t("footer.address")}</div>
        </div>
        <div className="min-w-fit flex flex-col gap-4">
          {datas.map((item, index) => (
            <div key={item.title}>
              <div className="font-bold">{t(item.title)}</div>
              <div>{item.content}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-[#000000] px-5 py-2 text-white text-center font-medium text-xs md:text-[15px] md:leading-[24px] w-full">
        <p>{t("footer.copyright")}</p>
      </div>
    </footer>
  );
}
